<template>
  <div :style="{ direction: $i18n.locale === 'en' || $i18n.locale === 'en_US' ? 'ltr' : 'rtl' }">
    <v-row>
      <!-- points display -->
      <v-col cols="12" class="d-flex justify-content-center">
        <v-icon right color="#F2D612"> mdi-star </v-icon>
        <v-chip
          class="ma-2"
          color="orange"
          text-color="white"
          v-text="formatNumber(point) + ' ' + $t('points.points')"
        >
        </v-chip>
        <v-icon right color="#F2D612"> mdi-star </v-icon>
      </v-col>
      <!-- section buttons -->
      <v-col cols="12" class="d-flex justify-content-around mt-5">
        <v-btn app rounded class="btn-point-sections"
          ><b>{{ $t("points.receivedAwards") }}</b></v-btn
        >
        <v-btn app rounded class="btn-point-sections"
          ><b>{{ $t("points.pointsHistory") }}</b></v-btn
        >
        <v-btn app icon class="btn-faq">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
      </v-col>
      <!-- slider -->
      <v-col cols="12">
        <div class="container">
          <Banner></Banner>
        </div>
      </v-col>
      <!-- tickets -->
      <v-col>
        <div class="container">
          <v-card class="discount d-flex">
            <v-col cols="6">
              <v-img
                height="135"
                contain
                src="https://coreland.sarvland.ir/contents/crpT586O1VSnFz8JQ08ezKOD5RmyppvXQQ3hk2yT.jpg"
              >
              </v-img>
            </v-col>
            <v-col cols="6" class="d-flex flex-column justify-content-between">
              <v-card-title>{{ $t("points.discountTitle") }}</v-card-title>
              <v-card-text>{{ $t("points.discountText") }}</v-card-text>
            </v-col>
            <div class="bottom left"></div>
            <div class="bottom right"></div>
          </v-card>
          <v-card class="discount d-flex mt-1">
            <v-col cols="6">
              <v-img
                height="135"
                contain
                src="https://coreland.sarvland.ir/contents/crpT586O1VSnFz8JQ08ezKOD5RmyppvXQQ3hk2yT.jpg"
              >
              </v-img>
            </v-col>
            <v-col cols="6" class="d-flex flex-column justify-content-between">
              <v-card-title>{{ $t("points.discountTitle") }}</v-card-title>
              <v-card-text>{{ $t("points.discountText") }}</v-card-text>
            </v-col>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Banner from "@/view/layout/home/Banner";
import num2persian from "num2persian";

export default {
  components: { Banner },
  props: ["point"],
  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
    };
  },
  methods: {
    formatNumber(number) {
      if (this.$i18n.locale === "fa") {
        return num2persian(number);
      } else if (this.$i18n.locale === "ar") {
        // تبدیل اعداد به فرمت عربی (یونیکد عربی)
        return number
          .toString()
          .replace(/\d/g, (d) => String.fromCharCode(d.charCodeAt(0) + 1728));
      } else {
        // انگلیسی: فرمت استاندارد
        return number.toString();
      }
    },
  },
};
</script>

<style scoped>
.txt-display-points {
  background: linear-gradient(
    90deg,
    rgba(255, 128, 0, 1) 0%,
    rgba(241, 255, 0, 1) 90%,
    rgba(255, 255, 255, 1) 100%
  );
  max-width: 15rem;
}

.txt-display-points .v-input__control {
  height: 2.5rem !important;
}

.txt-display-points .v-input__control .v-input__slot * {
  padding: 0 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
}

.txt-display-points .v-input__control .v-input__slot {
  min-height: 2.5rem !important;
}

.txt-display-points .v-input__control {
  width: auto !important;
}

.btn-faq {
  background-color: white !important;
}

.discount {
  background: linear-gradient(
    90deg,
    rgba(255, 128, 0, 1) 0%,
    rgba(241, 255, 0, 1) 90%,
    rgba(255, 255, 255, 1) 100%
  );
}
</style>
